function hideElements() {
    var divsToHide = document.getElementsByClassName("hiding-elements"); //array of elements
    for (var i = 0; i < divsToHide.length; i++) {
        divsToHide[i].style.display = "none";
    }
}

export default hideElements;